module.exports = __webpack_public_path__ + "img/login_pwd_logo.f9935faf.png";